import {CSSProperties} from 'react';

export enum LinkCardShape {
  RoundedLarge = 'rounded_large',
  RoundedSmall = 'rounded_small',
  Square = 'square',
}

export interface CardStyle {
  linkCardShape: LinkCardShape;
  linkCardColor: string;
  linkCardFontColor: string;
}

export const buildCSS = (cardStyle: CardStyle): CSSProperties => {
  return {
    backgroundColor: cardStyle.linkCardColor,
    color: cardStyle.linkCardFontColor,
    borderRadius: getCssForShape(cardStyle.linkCardShape),
  };
};

export const getRichLinkCardStyle = (style: CardStyle): CSSProperties => {
  const {borderRadius, ...otherProperties} = buildCSS(style);
  if (style.linkCardShape === LinkCardShape.RoundedLarge) {
    return {...otherProperties, borderRadius: '3rem', padding: '1.5rem'};
  }
  return {borderRadius, ...otherProperties};
};

const getCssForShape = (linkCardShape: LinkCardShape) => {
  switch (linkCardShape) {
    case LinkCardShape.RoundedLarge:
      return '9999px';
    case LinkCardShape.RoundedSmall:
      return '0.25rem';
    case LinkCardShape.Square:
      return '0';
  }
};
